import { Col } from 'reactstrap';
import BaseLoader from './parts/BaseLoader';
import CourseHistory from '../../../../../CurriculumProgressStudent/parts/CourseHistory';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface GradesHistoryProps {
  studyPlanEnrollmentId: string | undefined;
}

export default function GradesHistory({
  studyPlanEnrollmentId,
}: GradesHistoryProps) {
  const prefix = 'curriculumProgressStudent';
  const { t } = useTranslation();
  const texts = useMemo(
    () => ({
      history: {
        generalAverage: t(`${prefix}.history.generalPassedAverage`),
        coursesValidated: t(`${prefix}.history.coursesValidated`),
        noCourses: t(`${prefix}.history.noCourses`),
        download: {
          button: t(`${prefix}.history.downloadHistory`),
          failed: t(`${prefix}.history.downloadFailed`),
          success: t(`${prefix}.history.downloadSuccess`),
        },
      },
    }),
    [t],
  );

  if (!studyPlanEnrollmentId) {
    return (
      <div>
        {t('studentManagement.academicHistory.noStudyPlanEnrollmentId')}
      </div>
    );
  }

  return (
    <BaseLoader studyPlanEnrollmentId={studyPlanEnrollmentId}>
      {(data) => (
        <Col className="mt-4 px-0">
          <CourseHistory
            coursesValidated={data.history.coursesValidated}
            periods={data.history.periods}
            generalAverage={data.history.generalAvg}
            studyPlanEnrollmentId={+studyPlanEnrollmentId}
            texts={texts.history}
          />
        </Col>
      )}
    </BaseLoader>
  );
}
